import { render, staticRenderFns } from "./searchActivity.vue?vue&type=template&id=d2918cc4&scoped=true"
import script from "./searchActivity.vue?vue&type=script&lang=js"
export * from "./searchActivity.vue?vue&type=script&lang=js"
import style0 from "./searchActivity.vue?vue&type=style&index=0&id=d2918cc4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2918cc4",
  null
  
)

export default component.exports